import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import { fetchQuestionTypesSuccessAction } from '../actions/questionType';
type State = {
    questionType: {
        byId: { [id: string]: any } | null;
        allIds: Array<string | any> | null;
    };
    loading: boolean;
    attempted: boolean;
    errorMessage: null | any;
};
const INITIAL_STATE: State = {
    questionType: {
        byId: null,
        allIds: null,
    },
    loading: false,
    attempted: false,
    errorMessage: null,
};

const fetchQuestionTypes = (state: State): State => {
    return {
        ...state,
        loading: true,
        attempted: true,
    };
};

const fetchQuestionTypesSuccess = (
    state: State,
    action: PayloadAction<fetchQuestionTypesSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        questionType: {
            ...state.questionType,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchQuestionTypesFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const questionType = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_QUESTION_TYPES]: fetchQuestionTypes,
    [ActionTypes.FETCH_QUESTION_TYPES_SUCCESS]: fetchQuestionTypesSuccess,
    [ActionTypes.FETCH_QUESTION_TYPES_FAILED]: fetchQuestionTypesFailed,
});

export default questionType;
